module.exports = __webpack_public_path__ + "static/google-img-4c5a7bbb2f0a396769edbdf24f5e37e9.png";